import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import Router from 'vue-router'
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/Vocational',
    name: 'Vocational',
    component: ()=>import('@/views/Vocational')
  },
  {
    path: '/pubList',
    name: 'pubList',
    component: ()=>import('@/views/pubList')
  },
  {
    path: '/docList',
    name: 'docList',
    component: ()=>import('@/views/docList')
  },
  {
    path: '/Company',
    name: 'Company',
    component: ()=>import('@/views/Company')
  },
  {
    path: '/Introduce',
    name: 'Introduce',
    component: ()=>import('@/views/Introduce')
  },
  {
    path: '/Phone',
    name: 'Phone',
    component: ()=>import('@/views/Phone')
  }
]

const router = new VueRouter({
  routes
})

export default router
